import { store } from '@betacrew/jars-flux'
export const componentKey = "MANAGE_MEMBERS";

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setMemberData : (state, action) => {
            state.memberData = action.payload;
        },
        setSkip : (state, action) => {
            state.skip = action.payload;
        },
        setRowsPerPage : (state, action) => {
            state.rowsPerPage = action.payload;
        },
        setIsDesc : (state, action) => {
            state.IsDesc = action.payload;
        },
        setFilterText : (state, action) => {
            state.filterText = action.payload;
        },
        setLoadingState: (state, action) => {
            state.loadingState = action.payload;
        },
        setExportFile: (state, action) => {
            state.exportFile = action.payload;
        },
        setUploadedFile: (state, action) => {
            state.uploadedFile = action.payload;
        },
        setTotalMembers: (state, action) => {
            state.totalMembers = action.payload;
        },
        setSelectedMember: (state, action) => {
            state.selectedMember = action.payload;
        },
        setShowImportPopup: (state, action) => {
            state.showImportPopup = action.payload;
        },
        setMemberRoles: (state, action) => {
            state.memberRoles = action.payload;
        },
        setDisabledFields: (state, action) => {
            state.disabledFields = action.payload;
        },
        setShowUserInfoPopup: (state, action) => {
            state.showUserInfoPopup = action.payload;
        },
        selectPayer: (state, action) => {
            state.selectedPayers = [...action.payload];
        },
        setSelectedGroupIDs: (state, action) => {
            state.selectedGroupIDs = action.payload;
        },
        setIsAllowMemberToCreate: (state, action) => {
            state.isAllowMemberToCreate = action.payload;
        },
        setShouldLoadMemberList: (state, action) => {
            state.shouldLoadMemberList = action.payload;
        },
    }, 
    initialReducerState: {
        memberData: [],
        totalMembers: 0,
        rowsPerPage: 10,
        skip: 0,
        selectedPayers: [],
        selectedGroupIDs: [],
        IsDesc: true,
        filterText: "",
        loadingState: false,
        exportFile: {},
        disabledFields: [],
        uploadedFile: null,
        selectedMember: {},
        showImportPopup: false,
        memberRoles: [],
        showUserInfoPopup: false,
        shouldLoadMemberList: false,
        isAllowMemberToCreate: null,
    }
});

export const { setSelectedGroupIDs, selectPayer, setShowUserInfoPopup, setDisabledFields, setMemberRoles, setShowImportPopup, setLoadingState, setSelectedMember, setMemberData, setRowsPerPage, setSkip, setIsDesc, setFilterText, setExportFile, setUploadedFile, setTotalMembers, setShouldLoadMemberList, setIsAllowMemberToCreate } = actions;

